import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
export function Navigation() {
  return <motion.header className="fixed top-0 left-0 right-0 z-40 py-4 md:py-5 px-5 md:px-10 bg-ivory/85 backdrop-blur-md border-b border-rule/60" initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-141">
      <div className="max-w-6xl mx-auto flex items-center justify-between" data-id="element-142">
        <a href="#" className="flex items-center gap-3 group" data-id="element-143">
          <motion.img src="https://cdn.magicpatterns.com/uploads/rHthWeUzr7MBUJWzFJEumD/AVY_LOGO.svg" alt="AVY" className="h-10 w-10 md:h-11 md:w-11" whileHover={{
          rotate: 360
        }} transition={{
          duration: 0.8,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-144" />
        </a>

        <div className="flex items-center gap-5 md:gap-8" data-id="element-145">
          <span className="text-[10px] uppercase tracking-[0.2em] text-ink-mute hidden md:flex items-center gap-2 font-medium" data-id="element-146">
            <span className="w-1.5 h-1.5 rounded-full bg-red animate-pulse" data-id="element-147" />
            Private &amp; Confidential
          </span>
          <a href="https://avy.me" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-[11px] uppercase tracking-[0.18em] text-ink hover:text-red transition-colors font-bold" data-id="element-148">
            avy.me
            <ArrowUpRightIcon className="w-3 h-3" data-id="element-149" />
          </a>
        </div>
      </div>
    </motion.header>;
}